/**
 * Returns whether or not the user is allowed to share a broadcast (or highlight from a broadcast)
 * to social media. Based on a combination of the feature flags, account and broadcast settings.
 *
 * @param  {Object}    featureFlags A "feature flags" object
 * @param  {Account}   account The current account
 * @param  {Broadcast} broadcast The broadcast in question (or the broadcast to which the highlight belongs)
 * @return {bool}      True if the user can share to social media; false otherwise
 */
export function AllowSocial(featureFlags, account, broadcast) {
  // Make a feature flags const that looks like an object no matter what
  const ff = featureFlags || {};

  // Account content settings an extra features that look like an object no matter what
  const a = account || {};
  const accountContentSettings = a.content_settings || {};
  const accountExtraFeatures = a.extra_features || {};

  // Broadcast content settings that looks like an object no matter what
  const b = broadcast || {};
  const broadcastContentSettings = b.content_settings || {};

  // If media_token_restrictions, then flat-out "no".
  if (accountExtraFeatures.media_token_restrictions) {
    return false;
  }

  // No media token restrictions and no host restrictions feature -- good to go.
  if (!ff.host_restrictions) {
    return true;
  }

  // If we get here, the user has no media token restrictions, but they do have the host restrictions _feature_.
  // We need to see if it's actually configured, starting at the most specific level (broadcast) and moving up
  // to the account-level. We don't bother checking any channels because any social promotion would use the
  // single-broadcast channel.

  const hostRestrictionsAllowsSocial = (hostRestrictions) => {
    // If there IS a redirect URL, we can allow social because we can send folks there.
    // If there's no redirect URL, we can't allow social because they'd be stranded on boxcast.tv and
    // we don't know where else to send them.
    return !!hostRestrictions.redirectUrl;
  };

  if (broadcastContentSettings.hostRestrictions) {
    return hostRestrictionsAllowsSocial(broadcastContentSettings.hostRestrictions);
  } else if (a.content_settings.hostRestrictions) {
    return hostRestrictionsAllowsSocial(accountContentSettings.hostRestrictions);
  }

  // By default, return true to allow social sharing
  return true;
}



// WEBPACK FOOTER //
// ./app/utils/allow-social.js